export default __webpack_public_path__ + "static/media/JCI.4d98460c.png";